import { useSelector } from 'react-redux';
import {
  useIsEducatorsSurveyPending,
  useIsEducatorsWelcomeHolding,
  useIsEducatorsWelcomeVisible,
} from './useEducatorsSurveyPopup';

/**
 * The Educators popups form a queue: the welcome board greets the teacher, then
 * the survey follows once it closes.
 *
 * `isBlocking` is what the layout reads to hold back its own dismissible popups,
 * so neither Educators popup is buried under one of them. `isWelcomeVisible`
 * tells it which popup is holding the queue, since the welcome board is shown by
 * a component the layout would otherwise hold back along with the rest.
 *
 * The hold begins as soon as the survey is on course, well before it is on
 * screen. Opening it waits on a request and on the shared onboarding finishing,
 * whereas the popups it outranks open on nothing more than a user id — so a hold
 * that waited for either would leave them a window to appear in and then vanish
 * from.
 *
 * `isWelcomeHolding` covers the onboarding tasks, which the layout puts up in
 * place of the whole page rather than over it. Left alone they would replace the
 * Educators home before it had shown the board, and the board only offers itself
 * once, so it would be spent on a screen nobody saw.
 */
const useEducatorsPopupChain = (params) => {
  const isSurveyVisible = useSelector(
    (state) => state.educatorsSurvey.isVisible,
  );
  const isSurveyPending = useIsEducatorsSurveyPending(params);
  const isWelcomeVisible = useIsEducatorsWelcomeVisible();
  const isWelcomeHolding = useIsEducatorsWelcomeHolding();

  return {
    isBlocking: isSurveyVisible || isSurveyPending,
    isWelcomeVisible,
    isWelcomeHolding,
  };
};

export default useEducatorsPopupChain;
